<template>
	<div class="col">
		<div class="row">
			<div class="col-sm-9" id="managerWrapper">
				<isotope ref="managerCards" :options="getOptions()" :list="selectedManagers">
					<managerCard
						v-for="(manager, index) in selectedManagers"
						:key="index"
						:managerInfo="manager.obj"
						:index="manager.sortID"
						:id="index"
					/>
				</isotope>
			</div>
			<div class="col-sm-3"><managerFilter class="full-height" /></div>
		</div>
	</div>
</template>

<script>
import isotope from 'vueisotope';
import managerCard from '@/components/common/uiLayouts/managerCard.vue';
import managerFilter from '@/components/common/uiLayouts/managerFilter.vue';

export default {
    components: {
        isotope,
        managerCard,
        managerFilter,
    },
    data () {
        return {
            selectedManagers: null,
        };
    },
    beforeMount () {
        this.selectedManagers = this.tileData(this.$store.getters.getUnDeletedSelectedMangers);
        this.$emit('summary', this.selectedManagers);
    },
    mounted () {
        this.$nextTick(() => {
            this.updateManagerRank();
        });
    },
    methods: {
        getOptions () {
            return {
                itemSelector: '.twenty',
                percentPosition: true,
                getSortData: {
                    'Return (% - pa over 1y)': 'Return (% - pa over 1y)',
                    AUM: 'AUM',
                    'Standard deviation (% pa)': 'Standard deviation (% pa)',
                    'Max drawdown': 'Max drawdown',
                    Fee: 'Fee',
                    Rating: 'Rating',
                },
                sortAscending: {
                    'Return (% - pa over 1y)': false,
                    'Standard deviation (% pa)': true,
                    'Max drawdown': true,
                    AUM: false,
                    Fee: true,
                    Rating: false,
                },
                getFilterData: {
                    notdeleted (el) {
                        return !el.deleted;
                    },
                },
                filterBy: 'notdeleted',
                sortBy: 'Return (% - pa over 1y)',
                masonry: { columnWidth: 0 },
            };
        },
        topTrumps (manager) {
            this.expectedReturn.push(manager.expectedReturn);
            this.standardDeviation.push(manager.standardDeviation);
            this.maxDrawdown.push(manager.maxDrawdown);
            this.aum.push(manager.aum);
            this.fee.push(manager.fee);
            this.rating.push(manager.rating);
        },
        tileData (managers) {
            const managerData = [];
            for (const ii in managers) {
                managerData.push({
                    obj: managers[ii],
                    index: ii,
                    id: managers[ii].ticker,
                    deleted: managers[ii].deleted,
                });
                const valueData = [];
                for (const valuesIndex in this.$store.state.universe.data.keyData[managers[ii].ticker].values) {
                    valueData[this.$store.state.universe.data.valueFilter[valuesIndex].valueName] = this.$store.state.universe.data.keyData[
                        managers[ii].ticker
                    ].values[valuesIndex];
                }
                for (const val in valueData) {
                    managerData[ii][val] = valueData[val];
                }
                managerData[ii].obj.oIndex = ii;
            }
            return managerData; // this.managerData;
        },
        updateManagerRank () {
            for (let x = 0; x < this.$refs.managerCards.getFilteredItemElements().length; x += 1) {
                this.$set(this.selectedManagers[this.$refs.managerCards.getFilteredItemElements()[x].id], 'sortID', x);
            }
        },
    },
    computed: {
        managerDeleted () {
            return this.$store.state.ui.managerDeleted;
        },
        sortBy () {
            return this.$store.state.ui.managerGeneralOrder;
        },
        dataLoaded () {
            return this.$store.state.ui.loadState;
        },
    },
    watch: {
        managerDeleted (val) {
            if (val) {
                this.selectedManagers = this.tileData(this.$store.state.selectedManagers);
                this.$refs.managerCards.filter(this.getOptions().filterBy);
                this.$store.state.ui.managerDeleted = false;
                const objThis = this;
                setTimeout(() => {
                    objThis.updateManagerRank();
                }, 100);
            }
        },
        sortBy (val) {
            this.selectedManagers = this.tileData(this.$store.state.selectedManagers);
            this.$refs.managerCards.sort(this.$store.state.ui.managerGeneralOrder);
            this.$nextTick(() => {
                this.updateManagerRank();
            });
        },
        dataLoaded (val) {
            if (val === 'loaded') {
                this.selectedManagers = this.tileData(this.$store.state.selectedManagers);
                this.$refs.managerCards.sort(this.$store.state.ui.managerGeneralOrder);
                const objThis = this;
                setTimeout(() => {
                    objThis.updateManagerRank();
                }, 100);
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
/*FIX THE SCSS WITH THE IMPROVEMENTS LEARNT*/
.grid-sizer {
	width: 20%;
}
#managerWrapper {
	/*height: calc(100vh - 140px);*/
	overflow-x: hidden;
	overflow-y: auto;
	padding: 1rem;
}
</style>
